/**
 * Each time once (17 October 2026): when two specialists are free at the same time the page showed
 * it twice. The clinic assigns the specialist; the booking goes to the first one free.
 */
export function timesFor<T extends { startAt: string }>(slots: T[]): T[] {
  const seen = new Set<string>();
  return slots.filter((s) => {
    if (seen.has(s.startAt)) return false;
    seen.add(s.startAt);
    return true;
  });
}
